<template>
  <div
    class="
      contenedor-encuentro
      w-full
      max-w-full
      flex flex-col
      items-center
      sm:bg-transparent
    "
  >
    <div id="inicio"></div>
    <div class="marco-azul relative h-fit w-screen">
      <div class="fondo-azul absolute right-auto top-0">
        <base-icon
          v-if="!isUltrawide"
          icon-name="iconCintaAzul"
          class="inline-block"
          view-box="0 0 2800 2070"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMax slice"
        >
          <icon-cinta-azul icon-color="rgba(26, 22, 102, 1)" />
        </base-icon>

        <base-icon
          v-else
          icon-name="iconCintaAzul"
          class="inline-block"
          view-box="0 0 2800 2070"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-cinta-azul-ancha icon-color="rgba(26, 22, 102, 1)" />
        </base-icon>
      </div>
      <div
        class="
          encuentro-box
          relative
          flex flex-col
          items-center
          sm:flex-row
          z-100
        "
      >
        <div class="logo-encuentro relative sm:absolute">
          <base-icon
            icon-name="ELRCA"
            class="inline-block"
            view-box="0 0 450 610"
            width="100%"
            height="100%"
          >
            <icon-elrca />
          </base-icon>
        </div>
        <div class="encuentro-azul w-full flex justify-end">
          <div
            class="
              w-fit
              flex flex-col
              items-center
              sm:items-start
              font-subheading
              whitespace-nowrap
            "
          >
            <div class="encuentro-text-box text-center">
              <p class="text-amarillo">
                Encuentro Latinoamericano
              </p>
              <p class="text-gray-300">
                de Recreación Comunitaria.
              </p>
              <p class="abriendo text-red-600">
                Abriendo el Juego en Santa Fe
              </p>
            </div>
            <div class="fecha text-center pt-10 w-fit">
              <p class="numero text-amarillo drop-shadow">
                12 - 13 - 14
              </p>
              <p class="mes">
                de MAYO 2022
              </p>
            </div>
            <p class="lugar font-heading text-2xl pt-4 pb-10">
              Estación Belgrano - Santa Fe
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="
      de-que-trata
      relative
      text-azul
      w-5/6
      md:w-4/6
      mb-28
      font-heading
      text-justify text-2xl
      leading-10
      font-light
      mt-32
    "
    >
      <div
        class="contenido text-left sm:text-justify"
        v-html="encuentroPage.contenido"
      ></div>
    </div>


    <div 
      class=" contenedor-programa text-azulOscuro w-5/6 xl:w-full flex items-center flex-col mt-40 z-1 relative"
    >
      <div id="recorrido"></div>
      <h2 class="text-4xl sm:text-5xl uppercase inline w-fit  mb-10 sm:mb-20 font-subheading font-bold text-center">
        Programa ELRCAs 2022
      </h2>
      <div 
        class="contenedor-iconos-prop grid grid-cols-1 sm:grid-cols-3 gap-20 sm:gap-6 xl:gap-12 xl:my-8
        justify-items-center "
      >
        <item-propuesta 
          color="rgba(222, 200, 20, 1)"
          icono="Dice"
          text1="Dispositivos"
          text2="Lúdicos"         
          ruta="https://www.abriendoeljuego.ar/home/articulos/dispositivos-ludicos/"
          doble
        >
          <icon-dice />
        </item-propuesta>
        <item-propuesta 
          color="rgba(27, 132, 42, 1)"
          icono="Dice"
          text1="Paneles"
          text2="null"
          ruta="https://www.abriendoeljuego.ar/home/articulos/paneles/"
          view-box="0 0 57 77"
        >
          <icon-micro />
        </item-propuesta>
        <item-propuesta 
          color="rgba(57, 36, 216, 1)"
          icono="Dice"
          text1="Presentación"
          text2="de libros"
          ruta="https://www.abriendoeljuego.ar/home/articulos/presentaciones-de-libros-y-revistas/"
          doble
        >
          <icon-libros />
        </item-propuesta>
        <item-propuesta 
          color="rgba(216, 36, 54, 1)"
          icono="Dice"
          text1="Talleres"
          text2="null" 
          ruta="https://www.abriendoeljuego.ar/home/articulos/talleres/"
          view-box="0 0 57 77"              
        >
          <icon-taller />
        </item-propuesta>
        <item-propuesta 
          color="rgba(220, 163, 23, 1)"
          icono="Dice"
          text1="Relatos de"
          text2="experiencias"
          ruta="https://www.abriendoeljuego.ar/home/articulos/relatos-de-experiencia/"
          doble
        >
          <icon-mensaje />
        </item-propuesta>
        <item-propuesta 
          color="rgba(172, 24, 221, 1)"
          icono="Dice"
          text1="Tertulias"
          text2="null" 
          ruta="https://www.abriendoeljuego.ar/home/articulos/tertulias/"
          view-box="0 0 57 77"         
        >
          <icon-foco />
        </item-propuesta>
      </div>
    </div>
    <div
      class="boton-descargar m-10 z-50"
    >
      <boton-ver-mas
        to="https://www.abriendoeljuego.ar/home/articulos/programa-encuentro"
        link-externo
        borde="border-white"
        color="text-white"
        texto="Programa completo"
        class="encuentro bg-naranja hover:text-black text-2xl px-4 py-4 rounded-full  
        border-none font-light my-24"
      >
      </boton-ver-mas>   
    </div>

    <div id="recorrido"></div>
    <div
      class="recorrido relative text-azul
          w-5/6 md:w-4/6
          mt-16 mb-16
          font-heading text-justify text-2xl leading-10 font-light
        "
    >
      <div
        class="contenido text-left sm:text-justify"
        v-html="recorrido.contenido"
      ></div>
    </div>

    <base-iframe 
      nombre="slider-encuentro" 
      slug="encuentro-carrusel"
    >
    </base-iframe>

    <div class="inscripciones relative w-screen max-h-full">
      <div class="contenedor-imagen-inscripcion absolute w-full">
        <base-icon
          v-if="!isMovil && !isUltrawide && false"
          icon-name="CurvaInscripcion"
          class="inline-block"
          view-box="0 0 1400 1040"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion icon-color="rgba(26, 22, 102, 1)" />
        </base-icon>
        <base-icon
          v-else-if="isUltrawide&&false"
          icon-name="CurvaInscripcionUltrawide"
          class="inline-block"
          view-box="-15 0 2300 1050"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion-grande icon-color="rgba(26, 22, 102, 1)" />
        </base-icon>
        <base-icon
          v-else-if="false"
          icon-name="CurvaInscripcionMovil"
          class="inline-block"
          view-box="0 -0 1220 1930"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion-movil icon-color="rgba(26, 22, 102, 1)" />
        </base-icon>
      </div>

      <div
        class="w-full max-w-full h-fit text-white flex flex-col justify-center"
      >
        <div id="inscripcion"></div>
        <div
          class="
            inner-inscripciones
            flex flex-col
            font-light
            items-center
            relative
            z-200
            font-heading
            w-screen            
            self-center
          "
        >
          <img
            class="w-full h-full"
            :src="imagesPath + 'Collage.jfif'"
            alt="Collage"
          />
        </div>
      </div>
    </div>


    <div class="organiza z-10 mt-16 xl:mt-4 flex flex-col items-center">
      <p
        class="text-4xl text-center font-heading font-semibold text-azulOscuro"
      >
        Organizó:
      </p>
      <div class="contenedor-isotipo p-9">
        <router-link :to="{ name: 'inicio', params: { section: 'inicio' } }">
          <base-icon
            icon-name="isotipo-con-texto"
            class="inline-block"
            view-box="0 0 1600 1250"
            width="100%"
            height="100%"
          >
            <icon-isotipo-texto />
          </base-icon>
        </router-link>
      </div>
      <p
        class="
          text-4xl text-center
          font-heading font-semibold
          text-azulOscuro
          mt-16
        "
      >
        Junto a:
      </p>
      <item-sponsor
        nombre="Municipalidad de Santa Fe"
        :ruta="uploadsPath + '2022/04/01-Muni-Chiquito.png'"
        height="13rem"
      >
      </item-sponsor>
    </div>

    <div class="px-8 sponsors z-10 mb-16 sm:mb-40 w-full">
      <p
        class="
          max-w-full
          text-4xl text-center
          font-heading font-semibold
          text-azulOscuro
          mt-16
          mb-4
        "
      >
        Invitaron:
      </p>
      <div
        class="
          sponsor-icons
          flex flex-col
          items-center
          justify-center
          w-full
          mb-16
        "
      >
        <div
          class="
            first
            flex
            sm:flex-row
            flex-col
            items-center
            justify-center
            m-0
            sm:m-4
          "
        >
          <item-sponsor
            :ruta="uploadsPath + '2022/04/02-ISEF-Chiquito.png'"
            nombre="ISEF Santa Fe"
            height="11rem"
          >
          </item-sponsor>
          <item-sponsor
            :ruta="uploadsPath + '2022/04/Logo-Cultura.png'"
            nombre="Ministerio de Cultura Santa Fe"
            height="7rem"
          >
          </item-sponsor>
        </div>
        <div
          class="
            third
            flex
            sm:flex-row
            flex-col
            items-center
            justify-center
            m-0
            sm:m-4
          "
        >
          <item-sponsor
            :ruta="uploadsPath + '2022/04/Logo-Ansafe.png'"
            nombre="AMSAFE"
            height="10rem"
          >
          </item-sponsor>
          <item-sponsor
            :ruta="uploadsPath + '2022/04/05-CTERA.png'"
            nombre="CTERA"
            height="3.5rem"
          >
          </item-sponsor>
        </div>
      </div>
      <div
        class="
          declaraciones
          text-xl
          sm:text-2xl
          text-center
          font-heading font-normal
          text-azul
        "
        v-html="declaraciones.contenido"
      ></div>
    </div>
  </div>
</template>

<script>
import goSectionMixin from "@/mixins/goSectionMixin.js";
import visibilityHandle from "@/mixins/visibilityHandle.js";
import assetsHandle from "@/mixins/AssetsHandle.js";

import ItemSponsor from "../components/Encuentro/ItemSponsor.vue";
import IconCintaAzul from "../components/UI/icons/iconCintaAzul.vue";
import IconCintaAzulAncha from "../components/UI/icons/iconCintaAzulAncha.vue";
import IconIsotipoTexto from "../components/UI/icons/iconIsotipoTexto.vue";
import ItemPropuesta from '../components/Encuentro/ItemPropuesta.vue';
import IconCurvaInscripcion from "../components/UI/icons/iconCurvaInscripcion.vue";
import IconCurvaInscripcionMovil from "../components/UI/icons/iconCurvaInscripcionMovil.vue";
import IconCurvaInscripcionGrande from "../components/UI/icons/iconCurvaInscripcionGrande.vue";

import BaseIframe from "../components/BaseIframe.vue";

//TODO Lograr que se pueda cargar toda la información del encuentro en una única página

export default {
  components: {
    ItemSponsor,
    IconIsotipoTexto,
    IconCintaAzul,
    IconCintaAzulAncha,
    ItemPropuesta, 
    IconCurvaInscripcion,
    IconCurvaInscripcionMovil,
    IconCurvaInscripcionGrande,
    BaseIframe
  },
  mixins: [goSectionMixin, visibilityHandle, assetsHandle],
  data() {
    return {
    };
  },
  computed: {
    encuentroPage() {
      return this.$store.getters["wordpress/getEncuentro2022"];
    },
    declaraciones() {
      return this.$store.getters["wordpress/getDeclaraciones"];
    },
    recorrido() {
      return this.$store.getters["wordpress/getRecorrido"];
    },

  },
  created() {
    this.loadEncuentro();
  },
  methods: {
    loadEncuentro() {
      this.$store.dispatch("wordpress/loadPosts", "encuentro2022");
      this.$store.dispatch("wordpress/loadPosts", "encuentro-declaraciones");
      this.$store.dispatch("wordpress/loadPosts", "encuentro-recorrido");
    },
  },
};
</script>

<style>
.de-que-trata .contenido p {
  margin: 1rem 0;
}

.declaraciones li {
  margin: 1.5rem 0;
}

.third {
  height: 6rem;
}

.third .icono {
  height: 100% !important;
  max-height: 100%;
}
.third .icono.CTERA {
  height: 4rem !important;
}
.has-large-font-size {
  font-size: 2rem;
}

@media screen and (max-width: 640px) {
  .third {
    max-width: 15rem !important;
    height: auto;
  }

  .third .icono,
  .third .icono.CTERA {
    height: auto !important;
  }
}
</style>

<style scoped>
.sponsors li {
  list-style: none;
}

.contenedor-encuentro {
  background-color: rgb(249, 245, 234);
}

.contenedor-isotipo {
  width: 20rem;
}

.marco-azul {
  padding-top: 4rem;
  padding-bottom: 8rem;
}

.fondo-azul {
  height: 100%;
  left: -47%;
  width: 180%;
}

.encuentro-box {
  width: 100%;
}

.logo-encuentro {
  width: 148px;
  margin-bottom: 5vw;
}

.encuentro-text-box {
  font-size: 5vw;
  line-height: 6vw;
  letter-spacing: 0.01em;
}

.encuentro-text-box .abriendo {
  font-size: 4.5vw;
}

.encuentro-azul {
  border-radius: 27px;
  font-size: 2.1vw;
  line-height: 3vw;

  margin-right: 0vw;
  margin-left: 0vw;
  margin-top: 0vw;
  margin-bottom: 0vw;
  padding: 0;

  width: 100%;
  justify-content: center;
}

.lugar {
  color: rgba(255, 199, 0, 1);
  font-weight: 300;
  font-size: 3.5vw;
  line-height: 4vw;
}

.fecha {
  text-shadow: 4px 4px 6px rgb(0 0 0 / 50%);
  font-size: 12vw;
  line-height: 13vw;
  padding-top: 7vw;
}

.fecha .mes {
  color: rgba(172, 24, 221, 1);
  font-size: 8vw;
  line-height: 10vw;
}

.button-ver-mas.encuentro {
  padding: 0.7rem 2rem;
  font-size: 1.5rem;
  margin: 0;
  margin-top: 3vw;
}

.contenedor-imagen-inscripcion {
  width: 100%;
  height: 100%;
}

.inner-inscripciones {
  margin: 0px;
}

.inner-inscripciones a {
  margin-top: 0px;
}

.inner-inscripciones a img {
  width: 15rem;
}

.inner-inscripciones h2 {
  margin-top: 20px;
  font-size: 9vw;
  line-height: 9vw;
}
.fecha-inscripcion {
  padding: 2vw;
}
.fecha-inscripcion p {
  font-size: 5vw;
}

.lugar-inscripcion {
  font-size: 5vw;
  padding: 3vw;
}

.texto-inscripcion {
  font-size: 3.5vw;
}

.texto-gracias {
  font-size: 5vw;
  margin: 2rem;
}

.texto-aporte {
  font-size: 3vw;
  line-height: 3.5vw;
}

.prop-item .text {
  font-size: 4vw !important;
}

.boton-descargar {
  margin: 50px 5px;
}
@media screen and (max-width: 240px) {
  .marco-azul {
    padding-top: 4rem;
    padding-bottom: 8rem;
  }

  .button-ver-mas.encuentro {
    padding: 1.5vw 10vw;
    font-size: 7vw;
    margin: 0;
  }
  .fondo-azul {
    width: 51rem;
    left: -20rem;
  }

  .logo-encuentro {
    width: 60vw;
    margin-top: 2rem;
  }

  .lugar {
    padding: 10vw 0;
    line-height: 5vw;
  }

  .inner-inscripciones a img {
    width: 10rem;
  }
    .texto-gracias {
    margin: 1rem;
  }
  .inner-inscripciones {
    /* padding: 40vw 3vw; */
    padding: 17vw 5vw 27vw;
  }
}
@media screen and (min-width: 450px) {
  .encuentro-text-box {
    font-size: 4vw;
    line-height: 5vw;
  }

  .encuentro-text-box .abriendo {
    font-size: 3.6vw;
  }

  .fondo-azul {
  }

  .logo-encuentro {
    width: 45vw;
  }

  .contenedor-imagen-inscripcion {
    width: auto;
    /* height: 200vw; */
    height: 100%;
    min-width: 100%;
  }

  .inner-inscripciones {

  }

  .inner-inscripciones h2 {
    margin: 5vw;
  }

  .fecha {
    font-size: 12vw;
    line-height: 13vw;
    padding-top: 3vw;
  }

  .fecha .mes {
    font-size: 8.5vw;
    line-height: 8.5vw;
  }

  .lugar {
    font-size: 3.8vw;
  }

  .marco-azul {

  }

  .encuentro-azul {
    font-size: 2.1vw;
    line-height: 3vw;
    padding: 4vw 7vw 5vw 7vw;
  }

  .boton-descargar {
    margin: 2.5rem;
  }

  .de-que-trata {
    margin-top: 15vw;
  }

  .texto-gracias {
    margin: 4rem;
  }
  .organiza {
    width: 70%;
  }
}

@media screen and (min-width: 600px) {
  .fondo-azul {
    width: 230vw;
    left: -65vw;
  }

  .marco-azul {
    padding-top: 10rem;
    padding-bottom: 20vw;
  }

  .encuentro-box {
    width: 100%;
    height: fit-content;
    padding: 0 0 0 0;
    margin: 0;
  }

  .encuentro-azul {
    padding: 3.6vw 5vw 0vw 0vw;
    height: fit-content;
    margin: 0 0vw;
    max-width: 100%;
    justify-content: flex-end;
  }

  .logo-encuentro {
    height: 47vw;
    width: auto;
    left: 10vw;
    top: -5vw;
    position: absolute;
  }

  .encuentro-azul div {
    align-items: flex-start;
  }

  .encuentro-text-box {
    text-align: start;
    font-size: 3.2vw;
    line-height: 4.2vw;
  }

  .encuentro-text-box .abriendo {
    font-size: 3vw;
    line-height: 4.2vw;
  }

  .fecha {
    text-align: start;
    margin: 0 0;
    padding-top: 4.5vw;
  }

  .fecha .mes {
    font-size: 4.8vw;
    line-height: 6vw;
  }

  .fecha .numero {
    font-size: 5.6vw;
    line-height: 6vw;
  }

  .lugar {
    font-size: 2.3vw;
    line-height: 2.3vw;
    padding-bottom: 4vw;
    padding-top: 0vw;
  }

  .logo-encuento img {
    height: 100%;
    width: 100%;
  }
  .de-que-trata {
    margin-top: 12vw;
  }

  .contenedor-imagen-inscripcion {
    height: 113vw;
    width: 100vw;
  }
  .inner-inscripciones h2 {
    margin: 3vw;
    font-size: 3.4vw;
    line-height: 4vw;
  }

  .encuentro-inscripciones {
    font-size: 3vw;
    line-height: 4vw;
    display: inline-block;
    width: 63vw;
  }

  .encuentro-inscripciones span {
    display: inline;
    white-space: normal;
  }

  .fecha-inscripcion {
    padding: 1vw 2vw 1vw 2vw;
  }

  .fecha-inscripcion p {
    font-size: 4vw;
    line-height: 4vw;
  }

  .lugar-inscripcion {
    font-size: 2.5vw;
    line-height: 3.5vw;
    padding: 2vw 2vw 4vw 2vw;
  }

  .texto-inscripcion {
    font-size: 2.5vw;
    line-height: 3.5vw;
  }
  .texto-aporte {
    font-size: 2vw;
    line-height: 3vw;
  }

  .inner-inscripciones a {
    margin: 0vw;
  }

  .contenedor-iconos-prop {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .organiza {
    width: 50%;
  }
}

@media screen and (min-width: 640px) {
  .contenedor-encuentro {
    background-color: transparent;
  }

  .sponsor-icons .icono {
    margin: 2rem 3rem 2rem;
  }
  .texto-inscripcion {
    padding: 0.75rem;
    font-size: 1.7em;
    line-height: 2.2rem;
  }

  .texto-gracias {
    font-size: 3em;
    line-height: 3rem;
  }

  .contenedor-imagen-inscripcion {
    height: 80rem;
  }
}

@media screen and (min-width: 950px) {
  .fondo-azul {
    width: 200rem;
    left: auto;
  }

  .marco-azul {
    padding-top: 10rem;
    padding-bottom: 16rem;
    display: flex;
    justify-content: center;
  }

  .encuentro-box {
    margin: 0;
    width: 78rem;
  }

  .logo-encuentro {
    height: 44rem;
    width: auto;
    left: 0rem;
    top: -4.5rem;
  }

  .encuentro-text-box {
    text-align: start;
    font-size: 3rem;
    line-height: 4rem;
  }

  .encuentro-azul {
    padding: 4rem 0rem 0 0;
  }

  .encuentro-text-box .abriendo {
    font-size: 2.75rem;
    line-height: 4rem;
  }

  .fecha {
    margin: 0 0;
    text-align: start;
    font-size: 3rem;
    line-height: 4rem;
    padding-top: 4rem;
  }

  .fecha .mes {
    font-size: 4.4rem;
    line-height: 5rem;
  }

  .fecha .numero {
    font-size: 5.2rem;
    line-height: 6rem;
  }

  .lugar {
    font-size: 2.2rem;
    line-height: 3rem;
    padding-bottom: 4rem;
    padding-top: 0;
  }

  .de-que-trata {
    margin-top: 9rem;
  }

  .contenedor-imagen-inscripcion {
    height: 70rem;
  }

  .inner-inscripciones .button-ver-mas.encuentro {
    margin: 4rem;
  }

  .inner-inscripciones h2 {
    margin: 5rem;
    font-size: 3.3rem;
    line-height: 4rem;
  }

  .fecha-inscripcion {
    padding: 0.5rem;
    margin-top: 1rem;
  }

  .fecha-inscripcion p {
    padding: 0.5rem;
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .lugar-inscripcion {
    padding: 0.5rem;
    font-size: 2em;
    line-height: 2rem;
    margin: 3rem 0rem 5rem 0rem;
  }


  .texto-aporte {
    font-size: 1.6rem;
    line-height: 2rem;
  }

  .encuentro-inscripciones {
    font-size: 2rem;
    line-height: 3rem;
    width: 50rem;
  }
  .organiza {
    width: 50%;
  }
}

@media screen and (min-width: 1300px) {
  .fondo-azul {
    left: auto;
    width: 120%;
  }

  .marco-azul {
    padding-top: 12rem;
    padding-bottom: 15rem;
  }
  .button-ver-mas.encuentro {
    padding: 0.7rem 3rem;
    font-size: 2rem;
    margin: 0;
  }

  .encuentro-box {
    width: 88rem;
  }

  .encuentro-azul {
    padding: 4rem 0rem 0 0;
  }

  .logo-encuentro {
    height: 51rem;
    left: 0;
    top: -7rem;
  }

  .de-que-trata {
    margin-top: 20rem;
    margin-bottom: 14rem;
    width: 1000px;
    font-size: 2rem;
    line-height: 3rem;
    letter-spacing: 0.03em;
  }
  .contenedor-imagen-inscripcion {
    height: 80rem;
    width: 100vw;
  }

  .inner-inscripciones {
    margin-top: 4rem;
    margin-bottom: 10rem;
    max-width: 1100px;
    align-self: center;
  }

  .inner-inscripciones h2 {
    margin: 3rem;
    font-size: 4rem;
    line-height: 5rem;
  }

  .encuentro-inscripciones {
    font-size: 2.4rem;
    line-height: 4rem;
    width: 60rem;
  }

  .fecha-inscripcion {
    padding: 1rem 0rem;
  }

  .fecha-inscripcion p {
    font-size: 4rem;
    line-height: 5rem;
  }

  .lugar-inscripcion {
    font-size: 2.3rem;
    line-height: 6rem;
  }

  .texto-inscripcion {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }

  .texto-aporte {
    font-size: 2.1em;
    line-height: 2rem;
  }

  .inner-inscripciones a {
    margin: 0rem;
    font-size: 2.5rem;
  }

  .inner-inscripciones a img {
    width: 20rem;
  }
}
</style>